"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.kwhToWh = exports.mwhToWh = exports.kwhToMwh = exports.whToMwh = exports.gramsToTonnes = void 0;
const constants_1 = require("./constants");
const math_1 = require("./math");
const gramsToTonnes = (value, shouldRound = false) => shouldRound ? (0, math_1.round)(value / constants_1.ONE_MILLION) : value / constants_1.ONE_MILLION;
exports.gramsToTonnes = gramsToTonnes;
const whToMwh = (value, shouldRound = false) => shouldRound ? (0, math_1.round)(value / constants_1.ONE_MILLION) : value / constants_1.ONE_MILLION;
exports.whToMwh = whToMwh;
const kwhToMwh = (value, shouldRound = false) => shouldRound ? (0, math_1.round)(value / constants_1.ONE_THOUSAND) : value / constants_1.ONE_THOUSAND;
exports.kwhToMwh = kwhToMwh;
const mwhToWh = (value, shouldRound = true) => shouldRound ? (0, math_1.round)(value * constants_1.ONE_MILLION) : value * constants_1.ONE_MILLION;
exports.mwhToWh = mwhToWh;
const kwhToWh = (value, shouldRound = true) => shouldRound ? (0, math_1.round)(value * constants_1.ONE_THOUSAND) : value * constants_1.ONE_THOUSAND;
exports.kwhToWh = kwhToWh;
//# sourceMappingURL=converters.js.map